import Debounce from 'Utils/Debounce';

export default class GridBreak {
	constructor() {
		if (!window.CSS || !CSS.supports('color', 'var(--var-check)')) return;
		this.rootContainer = document.getElementById('root-container');
		if (!this.rootContainer) {
			console.error('No elmenet with #root-container found');
			return;
		}

		this.setValues();
		window.addEventListener('resize', Debounce(::this.setValues, 100));
	}

	setValues() {
		const docElementWidth = document.documentElement.clientWidth;

		let scrollBarWidth = window.innerWidth - docElementWidth;
		document.documentElement.style.setProperty('--sWidth', `${scrollBarWidth}px`);

		const rootContainerWidth = this.rootContainer.getBoundingClientRect().width;
		let containerOffset = window.innerWidth - rootContainerWidth;

		const documentToContainerOffset = rootContainerWidth - docElementWidth;
		if (documentToContainerOffset > 0) {
			containerOffset += documentToContainerOffset;
		}

		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);

		document.documentElement.style.setProperty('--cOffset', `${containerOffset / 2}px`);
	}
}
